import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { className: "container  mx-auto px-4 sm:px-6 lg:px-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "modal",
      style: _normalizeStyle(_ctx.style)
    }, null, 4),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Navbar),
      _createVNode(_component_router_view)
    ])
  ], 64))
}